import { Services } from '@sigma-frontend-libs/commons'

import { serviceTemplate } from '@/utils'

export default {
  mixins: [
    serviceTemplate({
      serviceName: Services.contracts,

      async inputFilter(result) {
        result.OwnerId = result?.OwnerId || result?.Owner?.id
        result.RequisiteId = result?.RequisiteId || result?.Requisite?.id
        result.CompanyId = result?.CompanyId || result?.Company?.id
        result.FileId = result?.FileId || result?.File?.id

        return result
      },

      async outputFilter(result) {
        if (!result?.FileId) {
          if (result?.File?.id) {
            result.FileId = result.File.id
          }
        }

        return result
      },

      find: {
        defaultFilter: {
          $scope: [ 'full' ],
          $search: undefined,
          // NOTE: пока сервис не умеет фильтровать по диапазону дат на стороне бэкенда
          // createdAt: {
          //   $gt: undefined,
          //   $lt: undefined
          // },
          // createdAtPreset: undefined,
          OwnerId: undefined,
          RequisiteId: undefined,
          CompanyId: undefined,
          signMethod: undefined
        }
      },

      has: { clone: false },

      formClass: '',
      width: 420
    })
  ]
}
